<template>
  <v-tooltip v-if="user.id && (isTrial || isFree)" location="bottom">
    <template #activator="{ props }">
      <div class="premium-btn mx-1 rounded-pill">
        <v-btn rounded size="small" variant="elevated" style="height: 32px; min-width: 0" v-bind="props"
               @click="openPremium()">
          <div class="hidden-sm-and-down align-center" style="display: flex">
            <v-icon class="mr-2">svgicon-crown</v-icon>
            <div style="line-height: 1.2">
              {{ $t('NAV.BECOME_PREMIUM') }}
              <div v-if="isTrial" :class="trialDaysLeft > 5 ? 'small' : 'text-errorred'">{{ trialDaysLeft }} {{ $t('NAV.TRIAL_DAYS_LEFT', trialDaysLeft) }}</div>
              <div v-else>{{ $t('NAV.FREE') }}</div>
            </div>
          </div>
          <div class="hidden-md-and-up align-center" style="display: flex">
            <v-icon class="mr-2">svgicon-crown</v-icon>
            <span v-if="isTrial" :class="trialDaysLeft > 5 ? null : 'text-errorred'">{{ trialDaysLeft }} {{ $t('GLOBAL.DAYS', trialDaysLeft) }}</span>
            <span v-else>{{ $t('NAV.FREE') }}</span>
          </div>
        </v-btn>
      </div>
    </template>
    {{ $t('NAV.BECOME_PREMIUM') }}
  </v-tooltip>
</template>

<style lang="scss">
  /* Create a custom CSS property that smoothly animates angles */
  @property --angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
  }

  .premium-btn {
    /* Main button container */
    position: relative;
    padding: 2px;
    cursor: pointer;
    overflow: hidden;

    /* Animated conic border created using ::before pseudo-element */
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: conic-gradient(from var(--angle), #46A0FE, #FFBE33, #7DD467, #46A0FE);
      animation: premium-btn-rotate 60s linear infinite;
    }

    > * {
      /* Inner text area of button */
      position: relative;
      background: rgb(var(--v-theme-surface));
      z-index: 1;
    }
  }

  /* Animation of the custom angle property */
  @keyframes premium-btn-rotate {
    0% {
      --angle: 0deg;
    }
    3% {
        --angle: 360deg;
    }
    6% {
      --angle: 720deg;
    }
    9% {
      --angle: 1080deg;
    }
    100% {
        --angle: 1080deg;
    }
  }
</style>

<script>
  import useUiNavigationStore from '@/stores/ui/navigation';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    data() {
      return {
        uiNavigationStore: useUiNavigationStore(),
        usersStore: useUsersStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      user() { return this.usersStore.user; },
      premiumExpireDate() {
        return this.user.company?.premiumExpireDate;
      },
      isFree() {
        return ! this.premiumExpireDate;
      },
      trialDaysLeft() {
        const daysLeft = moment(this.premiumExpireDate).endOf('day').diff(moment(), 'days');
        return Math.max(daysLeft, 0);
      },
      isTrial() { return this.usersAccessRightStore.isTrial; },
    },
    methods: {
      openPremium() {
        this.uiNavigationStore.setOpenedModal('premium-window');
      },
    },
  };
</script>
